module.exports = __webpack_public_path__ + "static/media/logo-dark-192.48eeba39.png";